import { Chip, type ChipPropsColorOverrides, styled } from '@mui/material';

interface ChipProps extends ChipPropsColorOverrides {
    overrideColor?: string
}

const CustomColorChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== 'overrideColor',
})<ChipProps>(({ overrideColor }) => ({
    backgroundColor: overrideColor ?? '',
    color: overrideColor ? 'primary' : 'default',
}));

export default CustomColorChip;